/* RESPONSIBLE TEAM: team-proactive-support */
import Service, { inject as service } from '@ember/service';
import type ArticleMultilingual from 'embercom/models/article-multilingual';

export default class EducateEventService extends Service {
  @service declare intercomEventService: $TSFixMe;

  owner = 'educate';
  eventName = 'educate-event';

  trackEducateArticleEvent(article: ArticleMultilingual, metadata: $TSFixMe = {}) {
    metadata.owner = this.owner;
    metadata.object = 'article';
    metadata.article_id = article.get('id');
    if (!metadata.collection_id) {
      // @ts-ignore - collection is a proxy Ember object so we need to use get
      metadata.collection_id = article.get('collection.id');
    }
    if (!metadata.section_id) {
      // @ts-ignore - section is a proxy Ember object so we need to use get
      metadata.section_id = article.get('section.id');
    }

    let eventName = metadata.eventName || this.eventName;
    delete metadata['eventName'];

    this.intercomEventService.trackEvent(eventName, metadata);
  }
}
